// extracted by mini-css-extract-plugin
export default {"description":"style_description__Go3C4","fade-in":"style_fade-in__oG6Ar","top":"style_top__1zdeu","image":"style_image__ysY+B"};